/** Locale-aware datetime format used in report tables and event forms. */
export const getDateFormatAndLocale = language => {
    switch (language) {
        case 'en':
            return {
                format: 'MM/DD/YYYY HH:mm:ss',
                locale: 'en',
            };
        case 'es':
            return {
                format: 'DD/MM/YYYY HH:mm:ss',
                locale: 'es',
            };
        case 'bg':
        default:
            return {
                format: 'DD.MM.YYYY г., HH:mm:ss ч.',
                locale: 'bg',
            };
    }
};
